import * as React from 'react';
import { getTooltipContent, stopPropagation } from './utils';
import * as styles from './index.css';

export interface IWorkHonestlyTooltipProps {
  levelNumber: number;
  levelName: string;
}

export const WorkHonestlyTooltip = ({ levelNumber, levelName }: IWorkHonestlyTooltipProps) => {
  return (
    <div className={styles['container']} onClick={stopPropagation}>
      <h4 className={styles['title']}>{levelName}</h4>
      {levelNumber > 2 && (
        <a
          className={styles['link']}
          href="https://hc.cian.ru/hc/ru/articles/360061362792"
          target="_blank"
          rel="noreferrer"
        >
          Участник программы «Работаю честно»
        </a>
      )}
      <div className={styles['content']}>{getTooltipContent(levelNumber)}</div>
    </div>
  );
};
